<!--选择平台内容弹框-->
<template lang="pug">
  modal-dialog(modal-scale="large")
    .modal-card(slot="card")
      .modal-header
        .modal-card-title 
          a.shop 选择优惠券
        .close-button(@click="modalClose")
      .modal-body
        .section-filter.is-horizontal
          .field-group.is-horizontal
            .field.is-keyword
              label.label 关键字搜索
              custom-input(v-model="filter_data.keywords", placeholder="优惠券名称", @keyupEnter="searchFilter(1)")
            .field.staff-wrapper
              label.label 优惠券类型
              custom-select(v-model="filter_data.coupon_type", :list="coupon_type_list", nameField="name")
            .field.staff-wrapper
              label.label 优惠券使用范围
              custom-select(v-model="filter_data.coupon_use_type", :list="coupon_use_type_list", nameField="name")  
            .field
              a.button.primary(@click="searchFilter(1)") 搜索
            .field
              a.button(@click="resetFilter") 重置
        empty-page(v-if="!data_list.length && is_initiated", :tip="'暂无内容'")
        .table-wrapper(v-if="data_list && data_list.length !== 0")
          table.table
            thead
              tr
                td(width="80")
                td(width="120") 优惠券名称
                td(width="60") 优惠券类型
                td(width="80") 优惠券金额（折扣）
                td(width="100") 使用范围
            tbody
              tr(v-for="item in data_list")
                td
                  .simple-td
                    div(:class="type===1?'checkbox':'radio'")
                      input(v-if="type===1", type="checkbox", :id="item.coupon_id", :value="item", name="modal", v-model="selected_item", :checked='item.selected')
                      input(v-if="type===2", type="radio", :id="item.coupon_id", :value="item.coupon_id", name="modal", v-model="selected_item_id", :checked='item.selected')
                      label.sepcific-setting(:for="item.coupon_id")
                td
                  .simple-td(v-text="item.coupon_name")
                td
                  .simple-td(v-if="item.coupon_type === 1") 代金券
                  .simple-td(v-if="item.coupon_type === 2") 兑换券
                  .simple-td(v-if="item.coupon_type === 3") 满减券
                  .simple-td(v-if="item.coupon_type === 4") 折扣券
                td {{item.coupon_type === 4 ? (item.discount_amount / 100) + ' 折' : '¥ ' + (item.discount_amount / 100)}}
                td
                  div(v-if="item.coupon_use_type")
                    .simple-td(v-if="item.coupon_use_type === 1") 小程序商城通用
                    .simple-td(v-if="item.coupon_use_type === 2") 指定分类
                    .simple-td(v-if="item.coupon_use_type === 3") 指定商品/服务
                    .simple-td(v-if="item.coupon_use_type === 4") 指定养护卡
                    .simple-td(v-if="item.coupon_use_type === 5") 线下买单/开单
                  .simple-td(v-else) --
        .tfoot
          pagination(:pagination-data="pagination_data", @input="paging")
      .modal-footer.level
        .level-left
          span 温馨提示：助力活动奖励优惠券仅支持库存为无限制优惠券
        .level-right
          a.button.large(@click="modalClose") 取消
          a.button.large.primary(v-if="selected_item", @click="complete") 确定
</template>

<script>
import ModalDialog from '@/components/generics/ModalDialog'
import CustomSelect from '@/components/generics/form/CustomSelect'
import CustomInput from '@/components/generics/form/CustomInput'
import EmptyPage from '@/components/generics/EmptyPage'
import ModalInteractions from '@/mixins/utilities/modalInteractions'
import marketingMixin from '@/mixins/modules/marketing'
import Pagination from '@/components/generics/Pagination'

export default {
  name: 'CouponsHelp',
  components: {
    ModalDialog,
    CustomSelect,
    CustomInput,
    EmptyPage,
    Pagination,
  },
  mixins: [ModalInteractions, marketingMixin],
  props: {
    array: {
      type: [Array, Object],
      default: () => [],
    },
    endTime: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: [String, Number],
      default: 1,
    },
  },
  data () {
    return {
      is_initiated: false,
      filter_data: { // 搜索条件
        keywords: '',
        coupon_type: {},  // 优惠券类型
        coupon_use_type: {}, // 优惠券使用返回
      },
      old_ids: [], // 之前选择的ids
      coupon_type_list: [ // 下拉选项 - 优惠券类型
        { id: 1, name: '代金券' },
        { id: 2, name: '兑换券' },
        { id: 3, name: '满减券' },
        { id: 4, name: '折扣券' },
      ],
      coupon_use_type_list: [ // 下拉选择 - 优惠券使用范围
        { id: 1, name: '小程序商城通用' },
        { id: 2, name: '指定分类' },
        { id: 3, name: '指定商品/服务' },
        { id: 4, name: '指定养护卡' },
        { id: 5, name: '线下买单' },
      ],
      data_list: [],
      pagination_data: { // 分页
        current_page: 1,
        per_page: 20,
        last_page: 1,
        total: 0,
      },
      selected_item: [], // 选中的
      selected_item_id: '', // 单选的时候，选中的id
    }
  },
  methods: {
    // 搜索按钮
    searchFilter (tag) {
      if (tag) {
        this.pagination_data.current_page = 1
      }
      this.fetchData()
    },
    // 重置
    resetFilter () {
      this.pagination_data.current_page = 1
      this.filter_data.keywords = ''
      this.filter_data.coupon_type = {}
      this.filter_data.coupon_use_type = {}
      this.fetchData()
    },
    // 获取优惠券列表
    async fetchData () {
      let params = {
        coupon_name: this.filter_data.keywords.trim(),
        coupon_type: this.filter_data.coupon_type.id || '',
        coupon_use_type: this.filter_data.coupon_use_type.id || '',
        end_time: '',
        page: this.pagination_data.current_page,
        per_page: this.pagination_data.per_page,
      }
      if (this.endTime && typeof this.endTime !== 'number') {
        params.end_time = new Date(this.endTime.replace(/-/g, '/') + ' 23:59:59').getTime() / 1000
      }
      try {
        const { response, result } = await this.helpCouponList(params)
        if (response.status === 200 && result.code === 0) {
          this.data_list = result.data
          this.pagination_data = result.meta
          let oldIds = [...this.old_ids]
          console.log(oldIds)
          // 把之前选择的优惠券放进选择的数组
          if (oldIds.length) {
            this.data_list.forEach(item => {
              if (oldIds.indexOf(item.coupon_id) !== -1) {
                this.selected_item.push(item)
                this.old_ids[oldIds.indexOf(item.coupon_id)] = ''
              }
            })
          }
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取优惠券列表失败',
            content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取优惠券列表失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
      this.is_initiated = true
    },
    // 分页
    paging (state, evt) {
      this.pagination_data = state
      this.searchFilter(0)
    },
    // 完成
    complete () {
      // 查看剩余的id 放进选择的数组
      this.old_ids.forEach((item, index) => {
        if (item) {
          this.selected_item.push(this.array[index])
        }
      })
      this.modalResolve(this.selected_item, this.type)
    },
  },
  mounted () {
    this.old_ids = this.array.map(item => {
      return item.coupon_id
    })
    if (this.type === 2) {
      this.selected_item_id = this.array[0] ? this.array[0].coupon_id : ''
    }
    this.fetchData() // 获取优惠券列表
  },
  watch: {
    selected_item_id (val) {
      this.selected_item = [this.data_list.filter(c => c.coupon_id === val)[0]] || []
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.modal-header
  padding 20px 24px
.modal-card
  width 950px !important
.modal-card-title
  overflow hidden
  .shop
    float left
    margin-right 20px
    color #353535
  .active
    border-bottom 2px solid #ffbb29
.modal-footer
  padding 12px 16px
.modal-body
  position relative
  height 420px
  display flex
  flex-direction column
  padding-bottom 36px
.table-wrapper
  padding 8px 16px
  flex-grow 1
  background standBackground
  .items
    + .items
      margin-top 8px
    display flex
    height 48px
    align-items center
    background #ffffff
    padding 0 16px
  .checkbox
    flex-shrink 0
    margin-right 16px
  .image
    width 32px
    height 32px
    flex-shrink 0
    margin-right 16px
  .item-content
    max-width 343px
    margin-right 16px
    font-size 13px
    line-height 16px
    flex-grow 1
    text-overflow ellipsis
    white-space nowrap
    overflow hidden
  .price-content
    font-weight bold
    width 100px
    flex-shrink 0
    font-size 13px
    line-height 16px
    text-overflow ellipsis
    white-space nowrap
    overflow hidden
.simple-td
  height 32px
  line-height 32px
  display flex
  align-items center
.limit-info
  font-size 13px
  color darker
  align-items center
  .count
    color mediumYellow
    margin-left 10px
.filter-wrapper
  flex-shrink 0
  box-sizing border-box
  background #e8e9eb
  padding 12px 16px
  display flex
  flex-direction row
.custom-select
  width 128px
  margin-right 8px
  flex-shrink 0
.custom-input
  flex-grow 1
  margin-right 8px
.filter-wrapper
  .button + .button
    margin-left 8px
.pagination
  flex-shrink 0
  height 36px
  display flex
  justify-content space-between
  align-items center
  padding 0 16px
  background #ffffff
  box-shadow 0 -1px 12px 0 rgba(0, 0, 0, 0.08)
.pagination-info
  font-size 13px
  line-height 16px
  color lightGrey
.page-turning
  font-size 13px
  line-height 16px
  color lightGrey
  height 100%
  display flex
  align-items center
  cursor pointer
  &.is-disabled
    opacity 0.2
    pointer-events none
  &:hover
    color mediumYellow
    .pre-icon
      background-image url('~@/assets/prev-hover.svg')
    .next-icon
      background-image url('~@/assets/next-hover.svg')
.pre-icon, .next-icon
  display inline-block
  width 16px
  height 16px
  background url('~@/assets/prev.svg') no-repeat center center
  background-size 14px
.next-icon
  background-image url('~@/assets/next.svg')
.img
  width 32px
  height 32px
.tfoot
  z-index 3
.radio
  width 16px
  height 16px
  label
    width 16px
    height 16px
    padding-left 14px
  input[type='radio']
    width 16px
    height 16px
.level-left
  margin 12px 0
  font-size 13px
  color red
</style>



// WEBPACK FOOTER //
// src/components/content/modal/CouponsHelp.vue